import { createClient, processLock } from '@supabase/supabase-js';

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://yjetvjaxuixuebcwcdgg.supabase.co';
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlqZXR2amF4dWl4dWViY3djZGdnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg1ODQ4OTMsImV4cCI6MjA4NDE2MDg5M30.5Pm3DFC0vxEWnapT93krUgSqXq0rZZRDXni8GfQ2KEs';

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    // Coordinates refresh-token rotation across tabs/windows of the SAME browser
    // (via the Web Locks API) so they can't race each other into rotating the same
    // refresh token twice and triggering "refresh token not found" on the loser —
    // the most common real-world cause of that error. Explicit here rather than
    // relying on the library's current default, since that default has changed
    // across supabase-js versions. Has no effect across genuinely separate
    // browsers/devices — concurrent logins from different devices are allowed by
    // design in this app, see App.tsx's sessionExpiredElsewhere handling.
    lock: processLock,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

export default supabase;
